import StackedBarChart from "./StackedBarChart";

const data = [
  {
    name: "Free phone",
    Answered: 566,
    Missed: 98,
  },
  {
    name: "High rate line",
    Answered: 0,
    Missed: 0,
  },
  {
    name: "Internatonal",
    Answered: 302,
    Missed: 22,
  },
  {
    name: "Local",
    Answered: 1672,
    Missed: 597,
  },
  {
    name: "Mobile",
    Answered: 19479,
    Missed: 5994,
  },
  {
    name: "National",
    Answered: 16665,
    Missed: 3192,
  },
  {
    name: "One phone",
    Answered: 2,
    Missed: 1,
  },
  {
    name: "Special service",
    Answered: 38,
    Missed: 1,
  },
  {
    name: "Other",
    Answered: 133,
    Missed: 16,
  },
];

export default function StackedBarChartDemo() {
  return (
    <div className="page-content">
      <StackedBarChart data={data} />
    </div>
  );
}
